var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"alt-alert",attrs:{"id":_vm.id,"variant":_vm.variant,"show":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }